export default __webpack_public_path__ + "static/media/finlist-low-turnover-m.577a6335.png";